import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { AuthService } from "../services";
import { PaymentService } from "../services/payment.service";
import { Router } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private paymentService: PaymentService,
    private router: Router,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          if (!request.url.endsWith("/auth/login")) {
            this.authService.logout();
            location.reload(true);
          }
        }

        if (err.status === 402) {
          let jobId = null;

          if (err.error && err.error.jobId) {
            jobId = err.error.jobId;
          }

          this.handlePayment(jobId);
        }

        if (err.status === 403) {
          this.router.navigate(["/"]);
          location.reload(true);
        }

        const error = err.error || err.statusText;
        return throwError(error);
      }),
    );
  }

  handlePayment(jobId: string, productId?: string) {
    this.paymentService.redirectUrl = "/dashboard/jobs";

    if (jobId) {
      this.router.navigate(["/payment"], {
        queryParams: { jobId: jobId },
      });
      return;
    }

    if (productId) {
      this.router.navigate(["/payment"], {
        queryParams: { pid: productId },
      });
      return;
    }

    console.log("❌ NO jobId OR productId FOUND");
  }
}
